import {CodeViewHeader} from '@github-ui/code-view-header'
import type {HeaderResponse} from '@github-ui/code-view-header/types'
import type {DataRouterFileOverviewPayload} from '@github-ui/code-view-types'
import {useMemo} from 'react'

import {extractOverviewFilesData} from './OverviewSidebar'

export interface MergedHeaderPayload {
  aboutData: HeaderResponse | undefined
  queryKey: readonly unknown[]
}

export interface OverviewHeaderProps {
  overview: Pick<DataRouterFileOverviewPayload['overview'], 'overviewFiles'>
  headerData: MergedHeaderPayload
}

export function OverviewHeader({overview, headerData}: OverviewHeaderProps) {
  const overviewFiles = useMemo(() => extractOverviewFilesData(overview), [overview])
  const {aboutData} = headerData

  if (!aboutData) {
    return null
  }

  return <CodeViewHeader {...aboutData} {...(overviewFiles ?? {})} />
}
